import { useState } from "react";
import api, { formatApiError } from "@/utils/api";
import { toast } from "sonner";
import { ShieldCheck, ShieldOff } from "lucide-react";

export const ConsentPill = ({ consent, testId }) => {
  if (consent === null || consent === undefined) return null;
  return consent
    ? <span className="inline-flex items-center gap-0.5 rounded-full border border-green-200 bg-green-50 px-1.5 text-[9px] font-semibold text-green-700" data-testid={testId}><ShieldCheck size={9} /> Consent</span>
    : <span className="inline-flex items-center gap-0.5 rounded-full border border-slate-200 bg-slate-50 px-1.5 text-[9px] font-semibold text-slate-500" data-testid={testId}><ShieldOff size={9} /> No consent</span>;
};

// Clickable pill: flips consent (and email opt-in) after a confirm.
export const ConsentToggle = ({ learner, onChanged }) => {
  const [busy, setBusy] = useState(false);
  const next = !learner.consent;
  const flip = async (e) => {
    e.stopPropagation();
    if (!window.confirm(next ? `Record that ${learner.name} has given consent? They will be included in group emails.` : `Remove consent for ${learner.name}? They will stop receiving group emails.`)) return;
    setBusy(true);
    try { await api.put(`/lms/admin/learners/${learner.id}/consent`, { consent: next }); toast.success(next ? "Consent recorded" : "Consent removed"); onChanged?.(next); }
    catch (err) { toast.error(formatApiError(err.response?.data?.detail) || "Couldn't update consent"); }
    finally { setBusy(false); }
  };
  return (
    <button type="button" disabled={busy} onClick={flip} title="Click to change consent" className="transition-opacity hover:opacity-75 disabled:opacity-50" data-testid={`consent-toggle-${learner.id}`}>
      {learner.consent === null || learner.consent === undefined
        ? <span className="inline-flex items-center rounded-full border border-dashed border-slate-300 px-1.5 text-[9px] font-semibold text-slate-500">Consent not recorded</span>
        : <ConsentPill consent={learner.consent} />}
    </button>
  );
};
